export enum StyleState {
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info'
}
